/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Settings_ProfilesInputs */

const en_task_settings_profiles = /** @type {(inputs: Task_Settings_ProfilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profiles that may receive this activity`)
};

const pt_br2_task_settings_profiles = /** @type {(inputs: Task_Settings_ProfilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfis que podem receber esta atividade`)
};

/**
* | output |
* | --- |
* | "Profiles that may receive this activity" |
*
* @param {Task_Settings_ProfilesInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_settings_profiles = /** @type {((inputs?: Task_Settings_ProfilesInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Settings_ProfilesInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_settings_profiles(inputs)
	return pt_br2_task_settings_profiles(inputs)
});